import React, { useEffect, useMemo, useState } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { updateSettings } from 'redux/modules/affiliate';
import Layout from '../../../affiliate/components/Layout';
import DashBoardLayout from '../../../affiliate/components/reusable/DashBoardLayout';
import { FlexContainer, FlexItem } from '../../../affiliate/styled/layout.styled';
import Form from '../../../affiliate/components/AccountSettings/Form';
import { Caption } from '../../../affiliate/styled/typograpghy.styled';
import DropDown from '../../../affiliate/components/reusable/DropDown/DropDown';
import useDropDown from '../../../affiliate/hooks/useDropDown';
import Toggle from '../../../affiliate/components/reusable/Toggle';
import useFetch from '../../../helpers/useFetch';
import AffiliateLoader from '../../../affiliate/components/reusable/AffiliateLoader';

const StyledFlexContainer = styled(FlexContainer)`
  width: 100%;
  border-radius: 4px;
  background-color: #1a0949;
`;

const StyledTitle = styled.h5`
  text-align: unset;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.color.white};
`;

const StyledToggleLabel = styled.label`
  color: #f0ecff;
  margin: 0 8px 0 0;
`;

const AccountSettings = () => {
  const {
    value, isItemInSelection, trigger, setTrigger, setValue,
  } = useDropDown();
  const [dropDownList, setDropDownList] = useState([]);
  const [reportValue, setReportValue] = useState(null);
  const {
    name,
    email,
    sot,
    commission_payout_address: commissionPayoutAddress,
    report_enable: reportEnable,
    payout_limit: payoutLimit,
    loading,
  } = useSelector(state => state.affiliate);
  const dispatch = useDispatch();
  const { data: payoutLimitList, loaded: payoutLimitListLoaded } = useFetch(
    '/api/v1/affiliate/account/payoutlimit/option'
  );
  const { payout_limit: payoutLimitDropDownList } = payoutLimitListLoaded ? payoutLimitList : [];

  useEffect(() => {
    setReportValue(() => reportEnable === 'Y');
    setValue(prev => ({ ...prev, name: `${(payoutLimit || 0).toFixed(6)} BSV`, value: payoutLimit }));
    setDropDownList(() => payoutLimitDropDownList);
  }, [loading, payoutLimit, payoutLimitListLoaded]);

  const listItems = useMemo(() => {
    let list = [];
    if (dropDownList) {
      dropDownList.forEach(item => {
        list = [...list, { name: `${parseFloat(item).toFixed(6)} BSV`, value: parseFloat(item) }];
      });
    }

    return list;
  }, [dropDownList]);

  const onChange = toggle => {
    setReportValue(prev => !prev);
    dispatch(updateSettings({ report_enable: !toggle ? 'Y' : 'N' }));
  };

  const onClickDropDownHandler = item => {
    setValue(item);
    setTrigger(false);
    dispatch(updateSettings({ payout_limit: item.value }));
  };

  return (
    <>
      <Helmet>
        <title>Account settings</title>
        <meta
          property="og:title"
          content="Peergame Partners - Partner up with the highest-paid commission casino affiliate program."
        />
        <meta
          name="description"
          content="The original Bitcoin SV Dice Game. Provably fair with the lowest house edge, instant payout, and enhanced privacy"
        />
      </Helmet>
      <Layout sideNav transparent>
        {loading || !payoutLimitListLoaded ? (
          <AffiliateLoader />
        ) : (
          <DashBoardLayout title="Account Settings" mobilePadding="22px 0 450px 0">
            <StyledFlexContainer flexDirection="column" margin="24px 0 8px 0" padding="32px" mobilePadding="16px">
              <Form name={name} email={email} sot={sot} commissionPayoutAddress={commissionPayoutAddress} />
              <FlexContainer alignItems="center">
                <StyledToggleLabel className="xsmall">Weekly Report Emails</StyledToggleLabel>
                <Toggle toggle={reportValue} onChange={onChange} />
              </FlexContainer>
            </StyledFlexContainer>

            <StyledFlexContainer flexDirection="column" padding="32px">
              <StyledTitle mobileMargin="0 0 16px 0">Payout Limit</StyledTitle>
              <Caption>
                You can select when you want to get paid your commissions automatically. We recommend 0.01000 BSV to
                prevent dust transactions
              </Caption>
              <FlexItem margin="16px 0 0 0" mobileMargin="24px 0 0 0" width="220px">
                <DropDown
                  listItems={listItems}
                  value={value}
                  isItemInSelection={isItemInSelection}
                  onCLickHandler={onClickDropDownHandler}
                  trigger={trigger}
                  setTrigger={setTrigger}
                />
              </FlexItem>
            </StyledFlexContainer>
          </DashBoardLayout>
        )}
      </Layout>
    </>
  );
};

export default AccountSettings;
